import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { Theme } from '@spoiler-alert/ui-library';
import QuillEditor from './quill-editor';

const useStyles = createUseStyles(
  {
    editor: {
      position: 'relative',
      zIndex: 100,
      height: '100%',
    },
    label: {
      fontWeight: 400,
      color: Theme.greyDark,
      margin: [20, 0, 0, 0],
    },
  },
  { name: 'HTMLEditor' },
);

const HTMLEditor = ({ onChange, defaultValue, className, disabled, placeholder, labelText }) => {
  const quillRef = useRef();
  const classes = useStyles();

  return (
    <div className={`${className} ${classes.editor}`}>
      {labelText && <h4 className={classes.label}>{labelText}</h4>}
      <QuillEditor
        ref={quillRef}
        defaultValue={defaultValue}
        onTextChange={onChange}
        readOnly={disabled}
        placeholder={placeholder}
      />
    </div>
  );
};

HTMLEditor.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  labelText: PropTypes.string,
};

export default HTMLEditor;
